import React from "react";

import InstrumentItemList from "./InstrumentItemList";
import { ManagementLayout } from "@components/shared";

export default function InstrumentItemManagement() {
  return (
    <ManagementLayout dataComponent={<InstrumentItemList />} />
  );
}
